export default "__VITE_ASSET__n__35XhB__"